import { generateEnumTranslations } from "@app/shared/enumTranslate/generateEnumTranslations";

export enum ChannelStatusEnum {
    Active = 1,
    Inactive = 2,
}

export const ChannelStatusTranslations = generateEnumTranslations(ChannelStatusEnum, 'channels.status');